import React from 'react';
import MagicForm from '../../../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../../Enums/MagicField.enum';

const FORM_SCHEMA: ItemScheme[] = [
	{
		type: MagicField.TEXT_FIELD,
		key: 'name',
		title: 'component.medicalHistoryConfigForm.name',
		settings: {
			required: true,
		},
	},
];

export interface MedicalHistoryConfigFormValues {
	name: string;
}

interface Props {
	onSubmit: (values: MedicalHistoryConfigFormValues) => void;
	submitText?: string;
	defaultValues?: MedicalHistoryConfigFormValues;
}

const MedicalHistoryConfigForm: React.FC<Props> = ({
	onSubmit,
	submitText,
	defaultValues,
}) => {
	return (
		<MagicForm
			formScheme={FORM_SCHEMA}
			onSubmit={onSubmit}
			submitText={submitText}
			defaultValues={defaultValues}
		/>
	);
};

export default MedicalHistoryConfigForm;
